import type { RouteRecordRaw } from 'vue-router';

import OnboardingLayout from '@/views/onboarding/OnboardingLayout.vue';

export default [
  {
    path: '/onboarding',
    component: OnboardingLayout,
    children: [
      {
        path: '',
        name: 'OnboardingStart',
        component: () =>
          import(
            /* webpackChunkName: "onboarding-start" */ '@/views/onboarding/start/StartPage.vue'
          ),
        meta: {
          showFooter: true,
        },
      },

      {
        path: 'quiz',
        name: 'OnboardingQuiz',
        component: () =>
          import(
            /* webpackChunkName: "onboarding-quiz" */ '@/views/onboarding/quiz/QuizPage.vue'
          ),
        meta: {
          showFooter: true,
        },
      },

      {
        path: 'pricing',
        name: 'OnboardingPricing',
        component: () =>
          import(
            /* webpackChunkName: "onboarding-pricing" */ '@/views/onboarding/pricing/PricingPage.vue'
          ),
        meta: {
          showFooter: true,
        },
      },

      {
        path: 'success',
        name: 'OnboardingSuccess',
        component: () =>
          import(
            /* webpackChunkName: "onboarding-success" */ '@/views/onboarding/payment-result/PaymentSuccessPage.vue'
          ),
        meta: {
          showFooter: false,
        },
      },

      {
        path: 'error',
        name: 'OnboardingError',
        component: () =>
          import(
            /* webpackChunkName: "onboarding-error" */ '@/views/onboarding/payment-result/PaymentErrorPage.vue'
          ),
        meta: {
          showFooter: false,
        },
      },
    ],
  },
] as RouteRecordRaw[];
